import {
  Cancel01Icon,
  FileSyncIcon,
  SentIcon
} from "@hugeicons-pro/core-stroke-rounded";
import {
  Button,
  ButtonVariant,
  IconButton,
  IconButtonSize,
  Radio
} from "shared/components";
import { Views } from "../types";
import { HugeiconsIcon } from "@hugeicons/react";
import { cx } from "shared/utils";
import { IconSvgObject } from "types/common/icons";

const RadioCard = ({
  icon,
  onClick,
  isChecked,
  title,
  description,
  readOnly
}: {
  isChecked: boolean;
  onClick: () => void;
  icon: IconSvgObject;
  title: string;
  description?: string;
  readOnly?: boolean;
}) => {
  const isActive = Boolean(isChecked);

  // Note: these RadioCards are `div`s for now because they are read-only.
  // When the AX side of this is added, these should be converted to `Card`s.
  return (
    <div
      className={cx(
        "p-5 flex justify-between items-center bg-content-1000-inverted rounded-lg border border-alpha-100 transition-all duration-200",
        isActive && readOnly ? "shadow-sm" : "shadow-xs"
      )}
      onClick={onClick}
    >
      <div
        className={cx(
          "size-10 rounded-lg flex items-center justify-center gap-4 mr-4 shrink-0",
          isActive ? "bg-primary-20" : "bg-alpha-40"
        )}
      >
        <HugeiconsIcon
          icon={icon}
          size={20}
          className={cx(isChecked ? "text-primary-500" : "text-content-100")}
        />
      </div>

      <div className="space-y-1 mr-auto">
        <h1 className="font-bold text-alpha-900">{title}</h1>
        {readOnly ? (
          <div className="py-0.5 px-2 bg-primary-20 text-[13px] font-medium text-primary-600 rounded-full w-fit">
            Coming soon
          </div>
        ) : (
          <p className="text-content-400 text-[13px] font-medium mr-6">
            {description}
          </p>
        )}
      </div>

      {!readOnly && (
        <Radio id={title} name="select-verification-type" checked={isChecked} />
      )}
    </div>
  );
};

export const AddIncomeSource = ({
  onClose,
  onContinue,
  onBack,
  selectedOption,
  setSelectedOption
}: {
  onClose: () => void;
  onContinue: () => void;
  onBack: () => void;
  selectedOption: Views;
  setSelectedOption: (value: Views) => void;
}) => {
  return (
    <div className="flex flex-col h-full">
      <header className="p-6 border-b border-alpha-100 flex justify-between">
        <div>
          <h1 className="text-xl text-content-1000 font-bold">
            Select verification type
          </h1>
          <p className="font-medium text-content-400 text-sm mt-1">
            You can verify by yourself or send a request to the applicant
          </p>
        </div>
        <IconButton
          HugeIcon={Cancel01Icon}
          size={IconButtonSize.SM}
          borderLess
          className="-mt-2 -mr-2 text-content-500"
          onClick={onClose}
        />
      </header>

      <div className="flex-grow bg-background-900 p-6 space-y-3">
        <RadioCard
          // Currently the only available option
          isChecked={true}
          onClick={() => setSelectedOption(Views.CombinedIncomeFlow)}
          icon={FileSyncIcon}
          title="Verify here with documents"
          description="Verify your income with pay stubs, W-2s, or benefit letters"
        />

        <RadioCard
          isChecked={selectedOption === Views.RequestApplicantAddIncome}
          readOnly
          onClick={() => null}
          icon={SentIcon}
          title="Send request to the applicant"
        />
      </div>

      <div className="px-6 py-4 border-t border-alpha-100 gap-2 flex justify-end w-full">
        <Button className="w-[125px]" onClick={onBack}>
          Back
        </Button>

        <Button
          className="w-[125px]"
          variant={ButtonVariant.PRIMARY}
          onClick={onContinue}
        >
          Continue
        </Button>
      </div>
    </div>
  );
};
